module.exports = __webpack_public_path__ + "img/promotion_01.9214256d.png";